module.exports = __webpack_public_path__ + "static/media/LifestyleWelcome.f46e6351.png";